import React, { Component } from 'react';
import { Form, Input, Modal } from 'antd';

const FormItem = Form.Item;
class ModalDormant extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleOk = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.handleOk(values);
      }
    });
  };

  render() {
    const {
      form: { getFieldDecorator },
      visible,
      loading,
      handleCancel,
    } = this.props;
    return (
      <Modal
        title="休眠原因"
        visible={visible}
        onOk={this.handleOk}
        onCancel={handleCancel}
        confirmLoading={loading}
      >
        <Form>
          <FormItem label="原因">
            {getFieldDecorator('refuse', {
              rules: [{ required: true, message: '请填写休眠原因' }],
            })(<Input />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(ModalDormant);



// WEBPACK FOOTER //
// ./src/components/incubator/bill/ModalDormant.js